import NewsletterSignup from '../components/NewsletterSignup'
import { pages } from '../data/content'

export default function Newsletter() {
  const { kicker, title, subtitle, dek, image } = pages.newsletter

  return (
    <main className="py-[clamp(28px,4.5vw,60px)]">
      <NewsletterSignup
        kicker={kicker}
        title={title}
        subtitle={subtitle}
        dek={dek}
        image={image}
      />
    </main>
  )
}
